import { Field, Form, Formik } from 'formik';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CONSTANTS } from '../../constants';
import { apiRoutes } from '../../constants/api-routes.constants';
import { UserEmailSchema } from '../../yupValidationSchemas/userEmail.validationSchema';
import AuthWelcomeBlock from '../AuthWelcomeBlock';
import ButtonComponent from '../UI/Button/Button.component';
import './request-reset-password.scss';

const initialState = {
  email: '',
};

const RequestResetPassword = () => {
  const navigate = useNavigate();
  const { fetchUserEmail, error } = useSelector((state: any) => state.user);

  useEffect(() => {
    if (fetchUserEmail?.data !== undefined) {
      navigate(apiRoutes.RESET_PASSWORD);
    }
  }, [fetchUserEmail]);

  const handleFetchUserEmail = (data: any) =>
    new Promise((resolve, reject) => {
      reject(Error);
    });

  return (
    <div className="ForgotPassword__Grid">
      <div className="ForgotPassword__Wrapper">
        <AuthWelcomeBlock header={CONSTANTS.USER.FORGOT_PASSWORD_TEXT} />
        <Formik
          initialValues={initialState}
          validationSchema={UserEmailSchema}
          onSubmit={(values) => {
            handleFetchUserEmail(values);
          }}
        >
          {({ errors, touched, isValid }) => (
            <Form className="ForgotPassword__Form needs-validation">
              <div className="ForgotPassword__UserInput">
                <Field
                  className={`ForgotPassword__FormInput form-control ${
                    errors.email && touched.email ? 'is-invalid' : ''
                  }`}
                  id="email"
                  name="email"
                  placeholder="Email"
                  type="text"
                />
                {errors.email && touched.email ? (
                  <p className="custom-invalid-feedback">{errors.email}</p>
                ) : null}
              </div>
              <ButtonComponent
                className="ForgotPassword__Button"
                variant="primary"
                disabled={
                  !isValid ||
                  (Object.keys(touched).length === 0 &&
                    touched.constructor === Object)
                }
                type="submit"
              >
                Submit
              </ButtonComponent>
            </Form>
          )}
        </Formik>
        {error?.message?.errorMessage && (
          <div className="form-group">
            <div className="alert alert-danger" role="alert">
              {error?.message?.errorMessage}
            </div>
          </div>
        )}
        <hr className="LoginUser__Ruler" />
      </div>
    </div>
  );
};

export default RequestResetPassword;
